// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "Question" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { QuestionResponseGenShape } from "./question-response.gen";

export const QuestionGenShape = z.strictObject({
  treeId: z.string(),
  text: z.string(),
  name: z.string().optional(),
  tagId: z.string().nullable().default(null),
  slug: z.string().optional(),
  info: z.string().optional(),
  responses: z.array(QuestionResponseGenShape),
  entryPoint: z.boolean().optional(),
  variableId: z.string().nullable().default(null),
  relatedQuestionId: z.string().nullable().default(null),
  libraryId: z.string(),
  created: z.string().optional(),
  createdUserId: z.string().optional(),
  lastEdited: z.string().optional(),
  lastEditedUserId: z.string().optional(),
  id: z.string(),
});
